//Swiper JS
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import { Navigation } from "swiper/modules";
// import { Virtual } from "swiper/modules";
// import { Keyboard } from "swiper/modules";
// import { Mousewheel } from "swiper/modules";
import { Pagination } from "swiper/modules";
// import { Scrollbar } from "swiper/modules";
// import { Parallax } from "swiper/modules";
// import { FreeMode } from "swiper/modules";
// import { Grid } from "swiper/modules";
// import { Manipulation } from "swiper/modules";
// import { Zoom } from "swiper/modules";
// import { Controller } from "swiper/modules";
// import { A11y } from "swiper/modules";
// import { History } from "swiper/modules";
// import { HashNavigation } from "swiper/modules";
import { EffectFade } from "swiper/modules";
// import { EffectCube } from "swiper/modules";
// import { EffectFlip } from "swiper/modules";
// import { EffectCoverflow } from "swiper/modules";
// import { EffectCards } from "swiper/modules";
// import { EffectCreative } from "swiper/modules";
import { Thumbs } from "swiper/modules";

Swiper.use([Autoplay, Navigation, EffectFade, Pagination, Thumbs]);

// Swiper CSS

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
// import "swiper/css/a11y";
// import "swiper/css/controller";
// import "swiper/css/effect-cards";
// import "swiper/css/effect-coverflow";
// import "swiper/css/effect-creative";
// import "swiper/css/effect-cube";
import "swiper/css/effect-fade";
// import "swiper/css/effect-flip";
// import "swiper/css/free-mode";
// import "swiper/css/grid";
// import "swiper/css/hash-navigation";
// import "swiper/css/history";
// import "swiper/css/keyboard";
// import "swiper/css/manipulation";
// import "swiper/css/mousewheel";
import "swiper/css/pagination";
// import "swiper/css/parallax";
// import "swiper/css/scrollbar";
import "swiper/css/thumbs";
// import "swiper/css/virtual";
// import "swiper/css/zoom";


const swiper = new Swiper('.swiper-projects', {
  speed: 600,
  spaceBetween: 20,
  slidesPerView: 1.15,
  breakpoints: {
    769: {
      slidesPerView: 1.5,
      spaceBetween: 40,
    },
    1200: {
      slidesPerView: 2.2,
      spaceBetween: 40,
    },
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false, // Allows navigation even if slides are partially off-screen
  },
  navigation: {
    nextEl: '.recent_projects .swiper-button-next',
    prevEl: '.recent_projects .swiper-button-prev',
  },
});

const swiper2 = new Swiper('.swiper-customers', {
  speed: 600,
  spaceBetween: 30,
  slidesPerView: 'auto',
  loop:true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  breakpoints: {
    769: {
      slidesPerView: 'auto',
    },
    1200: {
      slidesPerView: 'auto',
    },
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false, // Allows navigation even if slides are partially off-screen
  },
  navigation: {
    nextEl: '.customers .swiper-button-next',
    prevEl: '.customers .swiper-button-prev',
  },
});

const swiper3 = new Swiper('.swiper-testimonials', {
  speed: 600,
  spaceBetween: 20,
  slidesPerView: 1.1,
  breakpoints: {
    769: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1200: {
      slidesPerView: 2.5,
      spaceBetween: 60,
    },
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false, // Allows navigation even if slides are partially off-screen
  },
  navigation: {
    nextEl: '.testimonials .swiper-button-next',
    prevEl: '.testimonials .swiper-button-prev',
  },
});


const timelineBullets = new Swiper('.bullet-swiper', {
  speed: 600,
  spaceBetween: 0,
  slidesPerView: 2,
  watchSlidesProgress: true,
  breakpoints: {
    769: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 6,
    },
  },
});

const swiper4 = new Swiper(".swiper-timeline", {
  slidesPerView: 1,
  spaceBetween: 80,
  centeredSlides: true,
  //autoHeight: true,
  /*pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      let year = document.querySelectorAll(".swiper-slide")[index].dataset.year;
      return `<span class="${className}"><span class="dot"></span><span class="year">${year}</span></span>`;
    },
  },*/
  navigation: {
    nextEl: '.swiper-timeline .swiper-button-next',
    prevEl: '.swiper-timeline .swiper-button-prev',
  },
  thumbs: {
    swiper: timelineBullets,
  },
});




const swiper5 = new Swiper('.swiper-updates', {
  speed: 600,
  spaceBetween: 20,
  slidesPerView: 1.15,
  breakpoints: {
    769: {
      slidesPerView: 2,
      spaceBetween: 60,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false, // Allows navigation even if slides are partially off-screen
  },
  navigation: {
    nextEl: '.latest_updates .swiper-button-next',
    prevEl: '.latest_updates .swiper-button-prev',
  },
});

const swiper6 = new Swiper('.swiper-products', {
  speed: 600,
  spaceBetween: 20,
  slidesPerView: 1.15,
  breakpoints: {
    769: {
      slidesPerView: 1.5,
      spaceBetween: 40,
    },
    1200: {
      slidesPerView: 2.2,
      spaceBetween: 40,
    },
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false, // Allows navigation even if slides are partially off-screen
  },
  navigation: {
    nextEl: '.featured_products .swiper-button-next',
    prevEl: '.featured_products .swiper-button-prev',
  },
});


  const thumbSwiper = new Swiper('.thumb-swiper', {
    speed: 600,
    spaceBetween: 10,
    slidesPerView: 4,
    watchSlidesProgress: true,
  });

  const mainSwiper = new Swiper('.main-swiper', {
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.main-swiper .swiper-button-next',
      prevEl: '.main-swiper .swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });


  const swiperCarousel = new Swiper('.swiper-carousel', {
  speed: 600,
  spaceBetween: 100,
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false, // Allows navigation even if slides are partially off-screen
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true,
    dynamicMainBullets: 3,
  },
  navigation: {
    nextEl: '.swiper-carousel .swiper-button-next',
    prevEl: '.swiper-carousel .swiper-button-prev',
  }
});